import {useRef, useState} from 'react';
import {toast} from 'sonner';
import {useDeleteTaskComment} from '@api/tasks/hooks';
import type {TaskComment} from '@api/tasks/types';
import {taskCommentError} from './commentErrors';

/** Действия определяются только серверными правами комментария, а не ролью или статусом задачи. */
export const useTaskCommentActions = (taskId: string, comment: TaskComment) => {
  const remove = useDeleteTaskComment();
  const deleting = useRef(false);
  const [editing, setEditing] = useState(false);
  const deleteComment = async () => {
    if (comment.canDelete !== true || deleting.current) return;
    deleting.current = true;
    try {
      await remove.mutateAsync({taskId, commentId: comment.id});
      toast.success('Комментарий удалён');
    } catch (error) {
      toast.error(taskCommentError(error, 'delete'));
    } finally {
      deleting.current = false;
    }
  };
  return {
    editing: editing && comment.canEdit === true,
    setEditing,
    deleteComment,
    isDeleting: remove.isPending,
  };
};
